export const EMAIL_NOT_VERIFIED = 'email_not_verified';
export const EMAIL_NOT_UNIQUE = 'email_not_unique';

export const EMAIL_CODE_INVALID = 'email_code_invalid';
export const EMAIL_CODE_EXPIRED = 'email_code_expired';

const bannerErrors = [
  EMAIL_NOT_VERIFIED, 
  EMAIL_NOT_UNIQUE
];

const screenErrors = [
  EMAIL_CODE_EXPIRED,
  EMAIL_CODE_INVALID
];

export const isBannerError = (type) => bannerErrors.includes(type);
export const isScreenError = (type) => screenErrors.includes(type);

export const isUnknownError = (type) => !isBannerError(type) && !isScreenError(type);
